function createElement(type, attributes = {}, children) {
  return {
    ...attributes,
    type,
    children: typeof children === 'string' ? [{
      text: children
    }] : children
  };
}

export { createElement };
